var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueBubbles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 135,
    viewBox: "0 0 179 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5.13546 232.872C-11.7123 226.55 -22.1689 226.756 -28.4909 233.333C-34.8128 239.91 -34.6061 250.367 -28.0292 256.689C-21.4523 263.011 -10.9958 262.804 -4.67386 256.227C1.64808 249.65 1.44143 239.194 -5.13546 232.872Z",
    fill: "url(#paint0_linear_1091_804)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-35.5686 203.618C-42.1455 197.296 -52.602 197.503 -58.9239 204.08C-65.2459 210.657 -65.0392 221.113 -58.4624 227.435C-51.8855 233.757 -41.4289 233.55 -35.107 226.974C-28.785 220.397 -28.9917 209.94 -35.5686 203.618Z",
    fill: "url(#paint1_linear_1091_804)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-66.1668 174.206C-72.7437 167.884 -83.2002 168.091 -89.5222 174.668C-95.8441 181.244 -95.6375 191.701 -89.0606 198.023C-82.4837 204.345 -72.0271 204.138 -65.7052 197.561C-59.3832 190.985 -59.5899 180.528 -66.1668 174.206Z",
    fill: "url(#paint2_linear_1091_804)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2767 202.274C17.6998 195.952 7.24322 196.158 0.921284 202.735C-5.40066 209.312 -5.19397 219.769 1.38291 226.09C7.9598 232.412 18.4163 232.206 24.7383 225.629C31.0602 219.052 30.8536 208.595 24.2767 202.274Z",
    fill: "url(#paint3_linear_1091_804)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7094 231.527C48.1325 225.205 37.6759 225.411 31.354 231.988C25.032 238.565 25.2387 249.022 31.8156 255.344C38.3925 261.665 48.849 261.459 55.171 254.882C61.4929 248.305 61.2862 237.849 54.7094 231.527Z",
    fill: "url(#paint4_linear_1091_804)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.15645 173.02C-12.7333 166.698 -23.1899 166.905 -29.5118 173.482C-35.8337 180.058 -35.6271 190.515 -29.0502 196.837C-22.4733 203.159 -12.0168 202.952 -5.69481 196.375C0.62713 189.799 0.420432 179.342 -6.15645 173.02Z",
    fill: "url(#paint5_linear_1091_804)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-36.7547 143.608C-43.3316 137.286 -53.7881 137.493 -60.11 144.069C-66.432 150.646 -66.2253 161.103 -59.6484 167.425C-53.0716 173.747 -42.615 173.54 -36.293 166.963C-29.9711 160.386 -30.1778 149.93 -36.7547 143.608Z",
    fill: "url(#paint6_linear_1091_804)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-67.1873 114.355C-73.7642 108.033 -84.2208 108.239 -90.5427 114.816C-96.8647 121.393 -96.658 131.85 -90.0811 138.172C-83.5042 144.494 -73.0477 144.287 -66.7257 137.71C-60.4038 131.133 -60.6104 120.677 -67.1873 114.355Z",
    fill: "url(#paint7_linear_1091_804)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.829 -8.88716C103.253 -15.2091 92.796 -15.0024 86.474 -8.42558C80.1521 -1.84873 80.3587 8.60785 86.9356 14.9298C93.5125 21.2518 103.969 21.0451 110.291 14.4683C116.613 7.89138 116.406 -2.56521 109.829 -8.88716Z",
    fill: "url(#paint8_linear_1091_804)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.428 20.525C133.851 14.2031 123.394 14.4098 117.072 20.9866C110.75 27.5635 110.957 38.0201 117.534 44.342C124.111 50.664 134.567 50.4573 140.889 43.8804C147.211 37.3036 147.005 26.847 140.428 20.525Z",
    fill: "url(#paint9_linear_1091_804)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.861 49.7785C164.284 43.4566 153.827 43.6632 147.505 50.2401C141.183 56.8169 141.39 67.2736 147.967 73.5955C154.544 79.9175 165 79.7108 171.322 73.1339C177.644 66.557 177.438 56.1005 170.861 49.7785Z",
    fill: "url(#paint10_linear_1091_804)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4172 21.711C73.8404 15.3891 63.3838 15.5957 57.0619 22.1726C50.7399 28.7495 50.9466 39.206 57.5235 45.528C64.1003 51.8499 74.5569 51.6433 80.8789 45.0664C87.2008 38.4896 86.9941 28.033 80.4172 21.711Z",
    fill: "url(#paint11_linear_1091_804)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9846 -7.542C43.4077 -13.8639 32.9511 -13.6573 26.6292 -7.08047C20.3073 -0.5036 20.514 9.953 27.0908 16.275C33.6677 22.5969 44.1243 22.3902 50.4462 15.8133C56.7681 9.23649 56.5615 -1.22004 49.9846 -7.542Z",
    fill: "url(#paint12_linear_1091_804)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M111.015 51.1232C104.439 44.8013 93.982 45.0079 87.6601 51.5848C81.3382 58.1617 81.5448 68.6182 88.1217 74.9402C94.6986 81.2621 105.155 81.0555 111.477 74.4786C117.799 67.9017 117.592 57.4452 111.015 51.1232Z",
    fill: "url(#paint13_linear_1091_804)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M141.449 80.3767C134.872 74.0548 124.415 74.2614 118.093 80.8383C111.771 87.4151 111.978 97.8717 118.555 104.194C125.132 110.516 135.588 110.309 141.91 103.732C148.232 97.1552 148.025 86.6987 141.449 80.3767Z",
    fill: "url(#paint14_linear_1091_804)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M171.881 109.63C165.304 103.308 154.848 103.514 148.526 110.091C142.204 116.668 142.411 127.125 148.987 133.447C155.564 139.769 166.021 139.562 172.343 132.985C178.665 126.408 178.458 115.952 171.881 109.63Z",
    fill: "url(#paint15_linear_1091_804)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5297 171.841C46.9528 165.519 36.4962 165.726 30.1743 172.302C23.8523 178.879 24.059 189.336 30.6359 195.658C37.2128 201.98 47.6693 201.773 53.9913 195.196C60.3132 188.619 60.1066 178.163 53.5297 171.841Z",
    fill: "url(#paint16_linear_1091_804)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9624 201.094C77.3855 194.772 66.9289 194.979 60.607 201.556C54.285 208.132 54.4917 218.589 61.0686 224.911C67.6455 231.233 78.102 231.026 84.424 224.449C90.7459 217.872 90.5392 207.416 83.9624 201.094Z",
    fill: "url(#paint17_linear_1091_804)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M114.561 230.506C107.984 224.184 97.5271 224.391 91.2052 230.968C84.8833 237.545 85.0899 248.001 91.6668 254.323C98.2437 260.645 108.7 260.438 115.022 253.862C121.344 247.285 121.137 236.828 114.561 230.506Z",
    fill: "url(#paint18_linear_1091_804)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0966 142.587C16.5197 136.265 6.06314 136.472 -0.258805 143.049C-6.58074 149.626 -6.3741 160.082 0.202777 166.404C6.77966 172.726 17.2363 172.52 23.5582 165.943C29.8801 159.366 29.6734 148.909 23.0966 142.587Z",
    fill: "url(#paint19_linear_1091_804)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.50167 113.175C-14.0786 106.853 -24.5351 107.06 -30.857 113.637C-37.179 120.214 -36.9723 130.67 -30.3954 136.992C-23.8186 143.314 -13.362 143.107 -7.04004 136.531C-0.718093 129.954 -0.924792 119.497 -7.50167 113.175Z",
    fill: "url(#paint20_linear_1091_804)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M-37.9343 83.9222C-44.5112 77.6002 -54.9678 77.8068 -61.2897 84.3837C-67.6116 90.9606 -67.405 101.417 -60.8281 107.739C-54.2512 114.061 -43.7947 113.854 -37.4727 107.278C-31.1508 100.701 -31.3574 90.2441 -37.9343 83.9222Z",
    fill: "url(#paint21_linear_1091_804)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M-68.5325 54.51C-75.1094 48.1881 -85.566 48.3947 -91.8879 54.9716C-98.2098 61.5484 -98.0032 72.005 -91.4263 78.327C-84.8494 84.6489 -74.3929 84.4422 -68.071 77.8653C-61.749 71.2884 -61.9556 60.832 -68.5325 54.51Z",
    fill: "url(#paint22_linear_1091_804)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7827 141.408C76.2058 135.086 65.7492 135.293 59.4273 141.87C53.1053 148.447 53.312 158.903 59.8889 165.225C66.4658 171.547 76.9223 171.341 83.2443 164.764C89.5662 158.187 89.3596 147.73 82.7827 141.408Z",
    fill: "url(#paint23_linear_1091_804)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M113.215 170.661C106.638 164.339 96.1819 164.546 89.8599 171.123C83.538 177.7 83.7447 188.156 90.3216 194.478C96.8985 200.8 107.355 200.594 113.677 194.017C119.999 187.44 119.792 176.983 113.215 170.661Z",
    fill: "url(#paint24_linear_1091_804)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.814 200.074C137.237 193.752 126.78 193.958 120.458 200.535C114.136 207.112 114.343 217.569 120.92 223.891C127.497 230.212 137.953 230.006 144.275 223.429C150.597 216.852 150.39 206.396 143.814 200.074Z",
    fill: "url(#paint25_linear_1091_804)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3496 112.155C45.7727 105.833 35.3161 106.04 28.9942 112.616C22.6722 119.193 22.8789 129.65 29.4558 135.972C36.0327 142.294 46.4892 142.087 52.8112 135.51C59.1331 128.933 58.9264 118.477 52.3496 112.155Z",
    fill: "url(#paint26_linear_1091_804)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7513 82.7426C15.1744 76.4206 4.71789 76.6273 -1.60406 83.2042C-7.926 89.7811 -7.71933 100.238 -1.14245 106.56C5.43444 112.881 15.891 112.675 22.213 106.098C28.5349 99.5211 28.3282 89.0645 21.7513 82.7426Z",
    fill: "url(#paint27_linear_1091_804)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.68129 53.4896C-15.2582 47.1676 -25.7148 47.3743 -32.0367 53.9511C-38.3587 60.528 -38.1519 70.9846 -31.5751 77.3065C-24.9982 83.6285 -14.5417 83.4218 -8.21973 76.8449C-1.89778 70.2681 -2.10441 59.8115 -8.68129 53.4896Z",
    fill: "url(#paint28_linear_1091_804)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M-39.2795 24.0774C-45.8564 17.7554 -56.313 17.9621 -62.6349 24.539C-68.9569 31.1158 -68.7502 41.5724 -62.1733 47.8944C-55.5964 54.2163 -45.1399 54.0096 -38.818 47.4327C-32.496 40.8559 -32.7026 30.3994 -39.2795 24.0774Z",
    fill: "url(#paint29_linear_1091_804)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M112.195 110.81C105.618 104.488 95.1613 104.695 88.8394 111.272C82.5175 117.849 82.7242 128.305 89.301 134.627C95.8779 140.949 106.334 140.742 112.656 134.166C118.978 127.589 118.772 117.132 112.195 110.81Z",
    fill: "url(#paint30_linear_1091_804)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 140.063C136.051 133.741 125.594 133.948 119.272 140.525C112.95 147.102 113.157 157.558 119.734 163.88C126.311 170.202 136.767 169.995 143.089 163.419C149.411 156.842 149.204 146.385 142.627 140.063Z",
    fill: "url(#paint31_linear_1091_804)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M173.226 169.475C166.649 163.153 156.192 163.36 149.87 169.937C143.548 176.514 143.755 186.97 150.332 193.292C156.909 199.614 167.365 199.408 173.687 192.831C180.009 186.254 179.803 175.797 173.226 169.475Z",
    fill: "url(#paint32_linear_1091_804)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7617 81.5566C75.1848 75.2347 64.7283 75.4414 58.4063 82.0182C52.0844 88.5951 52.291 99.0516 58.8679 105.374C65.4448 111.696 75.9014 111.489 82.2233 104.912C88.5453 98.3352 88.3386 87.8786 81.7617 81.5566Z",
    fill: "url(#paint33_linear_1091_804)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1635 52.1444C44.5866 45.8225 34.13 46.0291 27.8081 52.606C21.4861 59.1829 21.6928 69.6394 28.2697 75.9614C34.8466 82.2833 45.3031 82.0767 51.6251 75.4998C57.947 68.923 57.7403 58.4664 51.1635 52.1444Z",
    fill: "url(#paint34_linear_1091_804)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7308 22.8914C14.154 16.5695 3.69736 16.7761 -2.62459 23.353C-8.94653 29.9298 -8.73981 40.3864 -2.16293 46.7084C4.41395 53.0303 14.8705 52.8237 21.1924 46.2468C27.5144 39.6699 27.3077 29.2134 20.7308 22.8914Z",
    fill: "url(#paint35_linear_1091_804)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M-9.86735 -6.52075C-16.4442 -12.8427 -26.9008 -12.6361 -33.2228 -6.0592C-39.5447 0.517669 -39.338 10.9742 -32.7611 17.2962C-26.1843 23.6181 -15.7278 23.4114 -9.40584 16.8346C-3.0839 10.2577 -3.29048 -0.198806 -9.86735 -6.52075Z",
    fill: "url(#paint36_linear_1091_804)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1091_804",
    x1: 37.3935,
    y1: 288.888,
    x2: -33.55,
    y2: -90.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176339,
    stopColor: "#64D9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BC8CEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBubbles);
export default __webpack_public_path__ + "static/media/blue_bubbles.14c2a93e401e34ec7c15d16dfec2cdad.svg";
export { ForwardRef as ReactComponent };